import { render, staticRenderFns } from "./VxJsonViewer.vue?vue&type=template&id=0029fdfc&"
import script from "./VxJsonViewer.vue?vue&type=script&lang=js&"
export * from "./VxJsonViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports